module.exports = __webpack_public_path__ + "img/dsci0061.22c346c6.jpg";